import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
export function App() {
  const [activePage, setActivePage] = useState('Dashboard');
  return <div className="flex h-screen w-full bg-gray-50 overflow-hidden font-sans" data-id="element-0">
      <Sidebar activePage={activePage} onNavigate={setActivePage} data-id="element-1" />
      <main className="flex-1 overflow-y-auto" data-id="element-2">
        <Dashboard activePage={activePage} data-id="element-3" />
      </main>
    </div>;
}